module.exports = __webpack_public_path__ + "img/maker_ladvik.b48f7b0a.jpg";